import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import axios from "axios"
import ReactXlsxExport from "react-xlsx-export"

import Grid from "@material-ui/core/Grid"
import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"
import ExploreOutlinedIcon from "@material-ui/icons/ExploreOutlined"
import EventOutlinedIcon from "@material-ui/icons/EventOutlined"
import LocalAtmIcon from "@material-ui/icons/LocalAtm"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import PinDropOutlinedIcon from "@material-ui/icons/PinDropOutlined"
import ViewHeadlineOutlinedIcon from "@material-ui/icons/ViewHeadlineOutlined"
import AvTimerOutlinedIcon from "@material-ui/icons/AvTimerOutlined"
import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined"
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined"
import RemoveCircleOutlinedIcon from "@material-ui/icons/RemoveCircleOutlined"
import Fab from "@material-ui/core/Fab"
import Button from "@material-ui/core/Button"
import AddIcon from "@material-ui/icons/Add"
import Alert from "@material-ui/lab/Alert"

import { checkTokenExpirationMiddleware } from "../../../../middlewares/users-auth.middleware"
import { createUploadState, uploadSelectedFile } from "../../../../helpers/attachment-helper"
import CustomSelect from "../custom-select"

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
}))

const TransportationOfferForm = ({ handleReloadOffers, reservationReqId }) => {
  const [items, setItems] = React.useState({
    items: [],
    loading: true,
    error: ""
  })
  const classes = useStyles()
  const [destination, setDestination] = useState(null)
  const [vehicleType, setVehicleType] = useState(null)
  const [error, setError] = useState(null)
  const [user] = useState(checkTokenExpirationMiddleware())
  const [addRow, setAddRow] = useState([])
  const [loader, setLoader] = useState(false)
  const [success, setSuccess] = useState(null)
  const [serverError, setServerError] = useState(null)
  const [uploadSuccess, setUploadSuccess] = useState({ loading: false, uploaded: false, error: false })
  const [attachmentUpload, setAttachmentUpload] = useState(createUploadState())

  const appendRow = () => {
    let rows = [...addRow]
    rows.push(1)
    setAddRow(rows)
  }

  const removeRow = () => {
    let rows = [...addRow]
    rows.pop()
    setAddRow(rows)
  }

  let headers = {
    Authorization: `Bearer ${user.Token}`
  }
  useEffect(() => {
    axios
      .get("/api/destination", { headers: headers })
      .then(res => {
        setDestination(res.data)
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
      })
    axios
      .get("/api/vehicletype", { headers: headers })
      .then(res => {
        setVehicleType(res.data)
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
      })
  }, [])

  const fileChangeHandler = async event => {
    const formData = new FormData()

    formData.append("excel", event.target.files[0])

    setUploadSuccess({ loading: true, uploaded: false, error: false })

    const response = await fetch(`${process.env.REACT_APP_API}/api/TransportationOffer/PostExcelSheetAsync`, {
      method: "POST",
      body: formData,
      headers: headers
    })
    const result = await response.json()

    console.log({ result: response.status })

    if (response.status === 400) {
      setUploadSuccess({ loading: false, uploaded: false, error: true, message: result.message })
    } else {
      setUploadSuccess({ loading: false, uploaded: true, error: false })
    }
  }

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/api/TransportationOffer/GetExcelDataAsync/${reservationReqId}`, { headers: headers })
      .then(({ data }) => {
        setItems({
          items: data.map(data => ({
            id: data.id,
            goingFromDestinationName: data.goingFromDestinationName,
            goingToDestinationName: data.goingToDestinationName,
            detailedAddress: data.detailedAddress,
            vehicleType: data.vehicleType,
            goingDate: data.goingDate,
            goingTime: data.goingTime,
            contactPerson: data.contactPerson,
            contactPersonTel: data.contactPersonTel,
            noofPersons: data.noofPersons,
            stop1: data.stop1,
            stop2: data.stop2,
            stop3: data.stop3,
            stop4: data.stop4,
            finalDestinationAddress: data.finalDestinationAddress,
            note: data.note,
            plannedTransportationBudget: data.plannedTransportationBudget,
            price: ""
          })),
          loading: false,
          error: ""
        })
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
        setItems({
          items: [],
          loading: false,
          error: "error"
        })
      })
  }, [reservationReqId])

  const handleAttachmentChange = async event => {
    await uploadSelectedFile({
      file: event.target.files.length > 0 ? event.target.files[0] : null,
      category: "transportation",
      token: user.Token,
      setUploadState: setAttachmentUpload
    })
  }

  const submitOffer = event => {
    event.preventDefault()
    setLoader(true)
    setError(null)
    let transportationRouteResources = []
    let transportationAttach = event.target.querySelector("#file-attach")
    let transportationTextArea = event.target.querySelectorAll("textarea")
    let transportationRoutes = document.querySelectorAll(".tr-rw")

    if (attachmentUpload.uploading) {
      setError("Attachment upload is still in progress.")
      setLoader(false)
      return
    }

    if (transportationAttach.files.length > 0 && !attachmentUpload.blobPath) {
      setError(attachmentUpload.error || "Upload the attachment before submitting the offer.")
      setLoader(false)
      return
    }

    for (let i = 0; i < transportationRoutes.length; i++) {
      let transportationRouteInputs = transportationRoutes[i].querySelectorAll("input")
      let transportationRouteResource = {
        Id: 0,
        TourismComTransportaionOfferId: 0,
        FromCityId: parseInt(transportationRouteInputs[0].value),
        ToCityId: parseInt(transportationRouteInputs[1].value),
        FromAddress: transportationRouteInputs[2].value,
        ToAddress: transportationRouteInputs[3].value,
        RouteDate: transportationRouteInputs[4].value,
        MovingTime: transportationRouteInputs[5].value,
        VehicleTypeId: parseInt(transportationRouteInputs[6].value),
        NoofCars: parseInt(transportationRouteInputs[7].value),
        CarPrice: parseInt(transportationRouteInputs[8].value),
        ContactPhoneNumber: transportationRouteInputs[9].value
      }
      transportationRouteResources.push(transportationRouteResource)
    }
    let transportationOfferResource = new FormData()
    transportationOfferResource.append("ReservationReqId", reservationReqId)
    transportationOfferResource.append("OfferHeadline", event.target.querySelector("#hd-ln").value)
    transportationOfferResource.append("ReservationSupplierTransportationOfferRouteResourcesJson", JSON.stringify(transportationRouteResources))
    transportationOfferResource.append("AttachmentFile", attachmentUpload.blobPath ? attachmentUpload.blobPath : "")
    transportationOfferResource.append("CancellationPolicy", transportationTextArea[0].value)
    transportationOfferResource.append("Notes", transportationTextArea[1].value)

    const config = {
      headers: {
        Authorization: `Bearer ${user.Token}`,
        Accept: "application/json",
        "content-type": "multipart/form-data",
        "Content-Encoding": "gzip"
      }
    }

    axios
      .post("/api/transportationoffer", transportationOfferResource, config)
      .then(res => {
        setSuccess(true)
        setTimeout(() => {
          setLoader(false)
          handleReloadOffers()
        }, 750)
      })
      .catch(err => {
        let errorMsg = "Error Adding Offer — Try again later!";
        if (err.response && err.response.data) {
          const data = err.response.data;
          if (data.errors) {
            errorMsg = Object.values(data.errors).flat().join(" | ");
          } else if (typeof data === "string") {
            errorMsg = data;
          }
        }
        setServerError(errorMsg);
        setSuccess(false);
        setTimeout(() => setLoader(false), 750)
      })
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader} style={{ zIndex: `2000` }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <form onSubmit={submitOffer}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="hd-ln"
              label={"Offer Headline"}
              helperText={"Write an uniqe/request offer headline. Recommended to contain your company name and the word 'transportation'(ex: CoolCompany Transportation Offer 1)"}
              fullWidth
              type={"text"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ViewHeadlineOutlinedIcon fontSize={"small"} />
                  </InputAdornment>
                )
              }}
              required
            />
          </Grid>
        </Grid>
        <RouteRow extra={false} removeRow={removeRow} destination={destination} vehicleType={vehicleType} />
        {addRow.map((item, index) => (
          <RouteRow key={index} extra={true} removeRow={removeRow} destination={destination} vehicleType={vehicleType} />
        ))}
        <Grid container justify="flex-end">
          <Fab size="small" color="primary" aria-label="add" onClick={appendRow}>
            <AddIcon />
          </Fab>
        </Grid>
        <Grid container item xs={12} spacing={2}>
          <Grid item sm={12} md={5} lg={5}>
            <TextField label="Cancellation Policy" fullWidth multiline rows={3} variant="outlined" required />
          </Grid>
          <Grid item sm={12} md={5} lg={5}>
            <TextField label="Notes" multiline fullWidth rows={3} variant="outlined" />
          </Grid>
          <Grid item sm={4} md={2} lg={2} container>
            <Grid item container>
              <input accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx" style={{ display: `none` }} id={`file-attach`} type="file" onChange={handleAttachmentChange} />
              <label style={{ width: "100%" }} htmlFor={`file-attach`}>
                <Button fullWidth variant="outlined" color="primary" component="span">
                  Attachment
                </Button>
              </label>
              {attachmentUpload.uploading ? <div style={{ marginTop: "8px" }}>Uploading attachment...</div> : null}
              {attachmentUpload.originalFileName ? <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div> : null}
            </Grid>

            <Grid item container style={{ margin: "5px 0px" }}>
              {items.loading ? (
                //
                <p>Excel loading</p>
              ) : items.error ? (
                <p>error in Excel</p>
              ) : (
                <ReactXlsxExport
                  data={items.items}
                  styles={{
                    padding: "10px 15px",
                    margin: 0,
                    color: "#3f51b5",
                    width: "100%",
                    justifyContent: "center",
                    border: "1px solid rgba(63, 81, 181, 0.5)",
                    borderRadius: "4px",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHight: 1.75
                  }}
                  filename="file"
                />
              )}
            </Grid>

            <Grid item container>
              <input onChange={fileChangeHandler} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: `none` }} id={`excel`} type="file" />
              <label style={{ width: "100%" }} htmlFor={`excel`}>
                <Button fullWidth variant="outlined" color="primary" component="span">
                  Upload Excel
                </Button>
              </label>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={6}>
          {uploadSuccess.loading ? ( //
            <p>Loading</p>
          ) : uploadSuccess.error ? (
            <Alert d variant="filled" severity="error">
              {uploadSuccess.message}
            </Alert>
          ) : uploadSuccess.uploaded ? (
            <Alert variant="filled" severity="success">
              Upload excel Successfully
            </Alert>
          ) : null}
          {/* {uploadSuccess === false ? (
            <Alert d variant="filled" severity="error">
              Error Uploading excel Successfully
            </Alert>
          ) : null}
          {uploadSuccess === true ? (
            <Alert variant="filled" severity="success">
              Upload excel Successfully
            </Alert>
          ) : null} */}
        </Grid>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={6}>
            {typeof error === "string" ? (
              <Alert variant="filled" severity="error">
                {error}
              </Alert>
            ) : null}
            {success === false && serverError ? (
              <Alert variant="filled" severity="error">
                {serverError}
              </Alert>
            ) : null}
            {success === true ? (
              <Alert variant="filled" severity="success">
                Offer Added Successfully
              </Alert>
            ) : null}
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={6}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              Submit Offers
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

const RouteRow = ({ extra, vehicleType, destination, removeRow }) => {
  return (
    <>
      <Grid container item xs={12} spacing={2} className="tr-rw">
        <Grid item sm={6} md={6} lg={2}>
          <CustomSelect data={destination} label={"From"} required={true} icon={<ExploreOutlinedIcon fontSize={"small"} />} />
        </Grid>
        <Grid item sm={6} md={6} lg={2}>
          <CustomSelect data={destination} label={"To"} required={true} icon={<ExploreOutlinedIcon fontSize={"small"} />} />
        </Grid>
        <Grid item sm={12} md={6} lg={4}>
          <TextField
            label={"From Address"}
            fullWidth
            type={"text"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinDropOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              )
            }}
            required
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4}>
          <TextField
            label={"To Address"}
            fullWidth
            type={"text"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinDropOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              )
            }}
            required
          />
        </Grid>

        <Grid item sm={4} md={4} lg={2}>
          <TextField
            label={"Route Date"}
            fullWidth
            type={"date"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EventOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              )
            }}
            required
          />
        </Grid>
        <Grid item sm={4} md={4} lg={2}>
          <TextField
            label={"Moving Time"}
            fullWidth
            type={"time"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AvTimerOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              )
            }}
            required
          />
        </Grid>
        <Grid item sm={4} md={4} lg={2}>
          <CustomSelect data={vehicleType} label={"Veichle Type"} required={true} icon={<AirportShuttleOutlinedIcon fontSize={"small"} />} />
        </Grid>
        <Grid item sm={4} md={4} lg={2}>
          <TextField
            label={"No. Of Cars"}
            fullWidth
            type={"number"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AirportShuttleOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              ),
              inputProps: { min: 1 }
            }}
            required
          />
        </Grid>
        <Grid item sm={4} md={4} lg={2}>
          <TextField
            label={"Price/Car"}
            fullWidth
            type={"number"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocalAtmIcon fontSize={"small"} />
                </InputAdornment>
              ),
              inputProps: { min: 1 }
            }}
            required
          />
        </Grid>
        <Grid item sm={4} md={4} lg={2}>
          <TextField
            label={"Contact Phone Number"}
            fullWidth
            type={"text"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ContactPhoneOutlinedIcon fontSize={"small"} />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        {extra === true ? (
          <Grid item sm={1} md={1} lg={1}>
            <RemoveCircleOutlinedIcon color="error" fontSize="small" onClick={() => removeRow()} />
          </Grid>
        ) : null}
      </Grid>
    </>
  )
}

export default TransportationOfferForm
